import classNames from 'classnames';
import * as React from 'react';

import { getTranslation, keys } from '../../../../../Resources/Translations';

interface EmptyCartProps {
    readonly isCartPage?: boolean;
}

export const EmptyCart = ({ isCartPage }: EmptyCartProps) => {
    return (
        <div className={classNames('EmptyCart', isCartPage && 'EmptyCart--CartPage')}>
            <img src="/dist/assets/images/empty-cart.svg" alt="empty cart icon" className="EmptyCart__Image" loading="lazy" />
            <div className="EmptyCart__Heading">{getTranslation(keys['cartSummary.emptyCartHeading'])}</div>
        </div>
    );
};
